import { Instance } from 'mobx-state-tree';
import model from './model';
import views from './views';

const Archive = model.views(views);

export interface IArchive extends Instance<typeof Archive> {}

export default Archive;
